import { ReactNode, SyntheticEvent } from 'react';
import { CheckboxVariant, VisualAsset } from 'core/flow/entities';
import { Checkbox } from '../../Checkbox';
import { FormControlLabel } from '../../FormControlLabel';
import { Typography } from '../../Typography';
import { VisualAssetImage } from '../../VisualAssetImage';

const illustrationSizePx = 64;

type CheckboxCardProps = {
  checked: boolean;
  value: string;
  image?: VisualAsset;
  onAnswerClick: (value: string, checked: boolean) => void;
  children?: ReactNode;
  disabled?: boolean;
};

export const CheckboxCard = ({
  checked,
  value,
  onAnswerClick,
  children,
  image,
  disabled,
  ...otherProps
}: CheckboxCardProps) => {
  const onChange = (event: SyntheticEvent<Element, Event>, selected: boolean) => {
    onAnswerClick((event.target as HTMLInputElement).value, selected);
  };

  const illustration = image ? (
    <VisualAssetImage image={image} width={illustrationSizePx} height={illustrationSizePx} />
  ) : null;

  return (
    <FormControlLabel
      control={<Checkbox icon={illustration} checkedIcon={illustration} />}
      label={<Typography variant="text-body-xs">{children}</Typography>}
      labelPlacement="bottom"
      checked={checked}
      onChange={onChange}
      value={value}
      variant={CheckboxVariant.CARD}
      disabled={disabled}
      {...otherProps}
    />
  );
};
